import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const CREATE_DIARY_MUTATION = gql`
  mutation CreateDiaryMutation($diary: TBL_DIARY_Input) {
    createDiary(diary: $diary)
  }
`;

const UPDATE_DIARY_MUTATION = gql`
  mutation UpdateDiaryMutation($diaryid: ID!, $diary: TBL_DIARY_Input) {
    updateDiary(DIARYID: $diaryid, diary: $diary)
  }
`;

const DELETE_DIARY_MUTATION = gql`
  mutation DeleteDiaryMutation($diaryid: ID!) {
    deleteDiary(DIARYID: $diaryid)
  }
`;

export default function useDiaryMutate() {
  const { mutate: createMutate } = useMutation(CREATE_DIARY_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_DIARY_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_DIARY_MUTATION);

  async function createDiary(diary) {
    try {
      const { data } = await createMutate({ diary });
      return data;
    } catch (error) {
      console.error('Error creating new diary entry:', error);
      addAlert('Error creating new diary entry', 'high', 4);
      throw error;
    }
  }

  async function updateDiary(diaryid, diary) {
    try {
      const { data } = await updateMutate({ diaryid, diary });
      return data;
    } catch (error) {
      console.error('Error updating diary entry:', error);
      addAlert('Error updating diary entry', 'high', 4);
      throw error;
    }
  }

  async function deleteDiary(diaryid) {
    try {
      const { data } = await deleteMutate({ diaryid });
      return data;
    } catch (error) {
      console.error('Error deleting diary entry:', error);
      addAlert('Error deleting diary entry', 'high', 4);
      throw error;
    }
  }

  return {
    createDiary,
    updateDiary,
    deleteDiary,
  };
}
